import { ExportService } from '@/export/ExportService';
import { HolisticFunctions } from '@/server';

export class FirebaseExportService implements ExportService {
  constructor(
    private readonly holisticFunctions: HolisticFunctions,
    private readonly storage: firebase.storage.Storage,
  ) {}

  public async downloadUrl(path: string): Promise<string | null> {
    try {
      return await this.storage
        .ref()
        .child(path)
        .getDownloadURL();
    } catch {
      return null;
    }
  }

  public async exportSurveysAndEmployeeData(): Promise<void> {
    await this.holisticFunctions.exportSurveysAndEmployeeData();
  }
}
